module.exports = __webpack_public_path__ + "assets/img/b906c36d30cc0e0aa0d1092b23859d9f.png";